import { useState, useEffect, useCallback } from "react";
import { db, timestamp } from "../../../firebase/config";
import firebase from "../../../firebase/compat";
import uuid from 'react-uuid';
import { client } from "../../../hooks/Client";
import sanitizeHtml, { DEFAULT_ALLOWED_TAGS, DEFAULT_ALLOWED_ATTR } from "../../../utils/sanitizeHtml";
import { useFirestoreAnalysisWords, useFirestoreGeneral } from "../../../firebase/useFirestore";
import MomentMeta from "../../Research/MomentMeta";

const AnalyseResponse = ({ item, setSaved, categoryID, moment, field, color }) => {
  const [allWords, setAllWords] = useState([]);
  const [responseWords, setResponseWords] = useState([]);

  // Hooks
  const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' };

  // Load all words for this category
  const allCategoryWords = useFirestoreAnalysisWords(field, moment, categoryID);
  // Load previously saved selections for this response
  const wordsSnapshot = useFirestoreGeneral('AnalysisWords', 'Response', item.ID || "");

  useEffect(() => {
    if (allCategoryWords) {
      setAllWords(allCategoryWords.map(w => w.Word));
    }
  }, [allCategoryWords]);

  useEffect(() => {
    if (wordsSnapshot) {
      setResponseWords(wordsSnapshot.map(w => w.Word));
    }
  }, [wordsSnapshot]);

  // Save multi-word selection
  const saveSelection = useCallback(async (text) => {
    if (!text) return;
    const id = uuid();
    await db.collection('AnalysisWords').doc(id).set({
      Word: text,
      CategoryID: categoryID,
      MomentID: moment,
      FieldID: field,
      Compagny: client,
      CompagnyID: client,
      Timestamp: timestamp,
      Response: item.ID,
      ID: id
    });
    await db.collection('QuestionnairesResponses')
      .doc(item.docid)
      .update({
        SelectedWords: firebase.firestore.FieldValue.arrayUnion(text)
      });
    setSaved(true);
  }, [categoryID, moment, field, item.ID, item.docid, setSaved]);

  // Handle user text selection
  const handleSelection = () => {
    const sel = window.getSelection();
    const text = sel.toString().trim();
    if (text) {
      saveSelection(text);
    }
    sel.removeAllRanges();
  };

  // Render the input with highlighted selections
  const renderWithHighlights = () => {
    let html = item.Input;

    responseWords.forEach(phrase => {
      if (!phrase.trim()) return; // Skip empty or whitespace-only phrases

      const escaped = phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${escaped})`, 'gi');
      html = html.replace(regex, `<mark style="background: ${color}">$1</mark>`);
    });

    // item.Input is respondent-supplied (often unauthenticated) answer text, so
    // any HTML in it must never execute. Sanitize after adding the <mark> spans:
    // our highlight markup survives, an <img onerror=...> payload is stripped.
    const safeHtml = sanitizeHtml(html, {
      allowedTags: [...DEFAULT_ALLOWED_TAGS, 'mark'],
      allowedAttr: [...DEFAULT_ALLOWED_ATTR, 'style'],
    });

    return <span dangerouslySetInnerHTML={{ __html: safeHtml }} />;
  };
  

  return (
    <div
      className="analyse-categorie-response-container"
      onMouseUp={handleSelection}
      style={{ cursor: 'text', userSelect: 'text' }}
    >
      <p>{renderWithHighlights()}</p>
      <p id='response-text-timestamp'>{item.Timestamp.toDate().toLocaleDateString("nl-NL", options)}</p>
      {/* <MomentMeta item={item.MomentID} id='response-text-timestamp'/> */}
    </div>
  );
};

export default AnalyseResponse;

